import { render, staticRenderFns } from "./MallMainPage.vue?vue&type=template&id=59a25837&scoped=true"
import script from "./MallMainPage.vue?vue&type=script&lang=js"
export * from "./MallMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a25837",
  null
  
)

export default component.exports